import { useMemo } from 'react';
import { Category } from '../domain/entities/category';
import { useParamsWithDefaults } from './useParamsWithDefaults';

type Props = {
  categories: Category[];
};
export const useSelectedCategoryId = (props: Props) => {
  const { categories } = props;

  const { categorySlug } = useParamsWithDefaults();

  const selectedCategoryId = useMemo(() => {
    const isCategorySlugValid =
      categorySlug &&
      categories.some((category) => category.slug === categorySlug);

    if (!isCategorySlugValid) {
      const firstCategory = categories[0];
      return firstCategory?.categoryId;
    }

    const category = categories.find((a) => a.slug === categorySlug);
    return category?.categoryId;
  }, [categories, categorySlug]);

  return selectedCategoryId;
};
